var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-img"},[_c('div',{staticClass:"wrap"},[_c('CtrlImg')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }